import './stripeElementsForm.scss';

export const stripeElementCardStyle = {
    base: {
        color: 'rgba(0, 0, 0, 0.87)',
        // eslint-disable-next-line max-len
        fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
            color: 'rgba(0, 0, 0, 0.54)'
        }
    },
    invalid: {
        color: '#dd2c00',
        iconColor: '#dd2c00'
    }
};

export const StripeElementsForm = angular
    .module('checkout.components.stripeElementsForm', [])
    .component('stripeElementsForm', {
        template: '<div id="stripe-card-element"></div>',
        bindings: {
            stripeElementsCard: '<',
            onStripeElementsCardChange: '<'
        },
        controller: class StripeElementsFormCtrl {
            constructor($timeout) {
                this.$timeout = $timeout;
            }

            $onInit() {
                this.$timeout(() => {
                    this.stripeElementsCard.mount('#stripe-card-element');
                    if (this.onStripeElementsCardChange) {
                        this.stripeElementsCard.addEventListener('change', this.onStripeElementsCardChange);
                    }
                });
            }

            $onDestroy() {
                this.$timeout(() => this.stripeElementsCard.unmount());
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/stripeElementsForm/stripeElementsForm.js